export default [
  // { link: "/portfolio", name: "Portfolio" },
  { link: "/", name: "Home" },
  { link: "/aboutme", name: "About" },
  { link: "/projects", name: "Project" },
  // { link: "/career", name: "Career" },
  // { link: "/freelancing", name: "Freelancing" },
  // { link: "/contact", name: "Contact" },
];
